/*
 * verify-result 照片验真结果块
 * Schema: { status, total, verified_count, failed_count, results: [{ photo_url, verified, status_msg, ... }] }
 */
import React from 'react'
import { tryParseJson, VerifyData } from './types'
import { useInvalidBlockWarning } from './useInvalidBlockWarning'
import './VerifyResultBlock.scss'

interface VerifyResultBlockProps {
  code: string
}

export const VerifyResultBlock: React.FC<VerifyResultBlockProps> = ({
  code
}) => {
  // 兼容 { results } / { data: { results } } / [...]
  const parsed = tryParseJson<any>(code)
  let data: VerifyData | null = null
  if (Array.isArray(parsed)) {
    data = {
      status: 'success',
      total: parsed.length,
      verified_count: parsed.filter((r: any) => r.verified).length,
      failed_count: parsed.filter((r: any) => !r.verified).length,
      results: parsed
    }
  } else if (parsed?.results) {
    data = parsed as VerifyData
  } else if (parsed?.data?.results) {
    data = parsed.data as VerifyData
  }

  // 流式中 JSON 未收齐时 silent 不渲染，避免闪"验真数据无效"（对齐 FileListBlock）；
  // 流式结束后仍无效 → useInvalidBlockWarning 会 console.warn 留排查线索
  const valid = !!data && Array.isArray(data.results) && data.results.length > 0
  useInvalidBlockWarning('verify-result', code, valid)
  if (!data || !Array.isArray(data.results) || data.results.length === 0) {
    return null
  }

  return (
    <div className="aiClerk-block-verify">
      <div className="aiClerk-block-verify__header">
        <span className="aiClerk-block-verify__total">共 {data.total} 张</span>
        <span className="aiClerk-block-verify__ok">
          ✓ 验证通过 {data.verified_count}
        </span>
        {data.failed_count > 0 && (
          <span className="aiClerk-block-verify__fail">
            ✕ 失败 {data.failed_count}
          </span>
        )}
      </div>
      <div className="aiClerk-block-verify__list">
        {data.results.map((r, i) => (
          <div
            key={i}
            className={`aiClerk-block-verify__item aiClerk-block-verify__item--${
              r.verified ? 'ok' : 'fail'
            }`}
          >
            <img
              src={r.photo_url}
              alt="verify"
              className="aiClerk-block-verify__photo"
            />
            <div className="aiClerk-block-verify__meta">
              <div className="aiClerk-block-verify__status">
                {r.verified ? '✓' : '✕'} {r.status_msg}
              </div>
              {r.photo_time && (
                <div className="aiClerk-block-verify__sub">{r.photo_time}</div>
              )}
              {r.photo_address && (
                <div className="aiClerk-block-verify__sub">
                  {r.photo_address}
                </div>
              )}
              {r.fail_reason && (
                <div className="aiClerk-block-verify__error">
                  {r.fail_reason}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
